// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ye7j","content":"styles_content__2Wq4z"};